const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const parse = (iso?: string): Date | null => {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatEventDateRange = (startIso?: string, endIso?: string): string => {
  const start = parse(startIso);
  const end = parse(endIso);

  if (!start && !end) return '-';
  if (!start || !end) {
    const single = (start ?? end) as Date;
    return `${MONTHS[single.getMonth()]} ${single.getDate()}, ${single.getFullYear()}`;
  }

  const sameYear = start.getFullYear() === end.getFullYear();
  const sameMonth = sameYear && start.getMonth() === end.getMonth();
  const sameDay = sameMonth && start.getDate() === end.getDate();

  if (sameDay) {
    return `${MONTHS[start.getMonth()]} ${start.getDate()}, ${start.getFullYear()}`;
  }

  if (sameMonth) {
    return `${MONTHS[start.getMonth()]} ${start.getDate()}–${end.getDate()}, ${start.getFullYear()}`;
  }

  if (sameYear) {
    return `${MONTHS[start.getMonth()]} ${start.getDate()} – ${
      MONTHS[end.getMonth()]
    } ${end.getDate()}, ${start.getFullYear()}`;
  }

  return `${MONTHS[start.getMonth()]} ${start.getDate()}, ${start.getFullYear()} – ${
    MONTHS[end.getMonth()]
  } ${end.getDate()}, ${end.getFullYear()}`;
};
